<fieldset name="access" class="form-user-access" ngModelGroup="userFormAccessFieldset">
    <table class="table table-hover table-borderless">
        <tbody>
            <tr>
                <td class="col-md-8 pt-3 text-right text-bold" translate>All modules</td>
                <td class="col-md-36" [attr.aria-label]="'Check all modules' | translate">
                    <div class="d-flex justify-content-start">
                        <form-field-material-switch name="all"
                                                    class="inline-block"
                                                    [(ngModel)]="allChecked"
                                                    (ngModelChange)="setAllChecked()">
                        </form-field-material-switch>
                    </div>
                </td>
            </tr>
            <tr *ngFor="let module of modules; let i = index; trackBy: trackByIndex">
                <td class="col-md-8 pt-3 text-right text-bold">{{ module.name }}</td>
                <td class="col-md-36" [attr.aria-label]="'Check ' + module.name | translate">
                    <div class="d-flex justify-content-start">
                        <form-field-material-switch [name]="'module' + i"
                                                    class="inline-block"
                                                    [(ngModel)]="module.value"
                                                    (ngModelChange)="onCheck()">
                        </form-field-material-switch>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</fieldset>
